const embededYoutubeVideo = (youtubeVideoLink: string) => {
  if (!youtubeVideoLink) return undefined;

  const pattern =
    /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|&v(?:i)?=))([^#&?]*).*/;
  const matches = youtubeVideoLink.match(pattern);
  if (!matches || matches.length < 2 || !matches[1]) return undefined;
  const videoId = matches[1];

  return `<iframe
    width="100%"
    height="315"
    src="https://www.youtube.com/embed/${videoId}"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen></iframe>`;
};

export default embededYoutubeVideo;
